import { alereAxios } from '../utils/api';

export const fetchTreatmentGraph = ({ startDate, endDate, timeframe }) =>
  alereAxios.get('treatments/graphs', {
    params: { startDate, endDate, timeframe },
  });
